import { FC } from 'react'
import clsx from 'clsx'
import { IoAdd, IoRemove } from 'react-icons/io5'
import { TPilgrim } from '../../../store/features/per-reserve/reserveNewPreReserve/types'
import persianDate from '../../../utils/persianDate'
import EditIcon from '../../../components/icons/EditIcon'

type IProps = {
  data: TPilgrim[]
  cols: string | number
  cardType: 'Add' | 'Remove'
  classes?: string
  canRemoveLeader?: boolean
  updateBirthday?: boolean
  handleClick?: (nationalCode: string) => void
  handleChangeBirthday?: (nationalCode: string) => void
}

const PilgrimCard: FC<IProps> = ({
  data,
  cols,
  classes,
  cardType,
  canRemoveLeader = false,
  updateBirthday = true,
  handleClick,
  handleChangeBirthday,
}) => {
  return (
    <>
      {data?.map((item) => (
        <div
          key={item.nationalCode}
          className={clsx(
            `w-full grid group
              grid-cols-${String(cols)}
             bg-neutral-50 shadow-sm rounded-lg px-5 py-4 text-xs sm:text-sm last:mb-4 md:last:mb-0 cursor-pointer ease-in-out duration-200
              ${classes}
              `,
            cardType === 'Add' && 'hover:bg-lime-200',
            cardType === 'Remove' && 'hover:bg-red-200 ',
            item.isLeader && 'text-gray-600 bg-green-300',
            canRemoveLeader ? ' hover:bg-red-200' : ' hover:bg-green-300',
          )}
        >
          <span className='inline-block text-center'>{item.martyrNumber}</span>
          <span className='inline-block text-center'>{item.firstName}</span>
          <span className='inline-block text-center'>{item.lastName}</span>
          <span className='inline-block text-center'>{item.nationalCode}</span>
          <span className='inline-block text-center'>{item.fatherName}</span>
          {item.isLeader && updateBirthday ? (
            <span
              className='flex items-center justify-center text-center'
              onClick={() => handleChangeBirthday?.(item.nationalCode)}
            >
              <span>{persianDate(item.birthDate)}</span>
              <span className='mr-2'>
                <EditIcon className='w-5 h-5 text-gray-400 hover:text-gray-600 duration-200 ease-in-out' />
              </span>
            </span>
          ) : (
            <span className={clsx('inline-block', updateBirthday ? 'mr-4' : 'text-center')}>
              {persianDate(item.birthDate)}
            </span>
          )}
          {
            <span
              onClick={() => handleClick?.(item.nationalCode)}
              className='flex items-center justify-center hover:scale-125'
            >
              {cardType === 'Add' ? (
                <IoAdd className='w-4 h-4 md:w-5 md:h-5 group-hover:text-green-700' />
              ) : (
                <IoRemove className='w-4 h-4 md:w-5 md:h-5 group-hover:text-red-700' />
              )}
            </span>
          }
        </div>
      ))}
    </>
  )
}

export default PilgrimCard
